export const appRegistrationId = process.env.REACT_APP_APP_REGISTRATION
export const redirectUrl = process.env.REACT_APP_REDIRECT_URL
export const postmortemApiEndpoint = process.env.REACT_APP_POSTMORTEM_API_ENDPOINT
export const imageApiEndpoint = process.env.REACT_APP_IMAGE_API_ENDPOINT
export const azureAdTenant = process.env.REACT_APP_AZURE_AD_TENANT
export const wrapperApiConsumerKey = process.env.REACT_APP_WRAPPER_API_CK
export const reportUrl = process.env.REACT_APP_REPORTURL
export const postmortemSupportTeamsChannel = process.env.REACT_APP_POSTMORTEM_SUPPORT_TEAMS_CHANNEL
export const postmortemPortalDocs = process.env.REACT_APP_POSTMORTEM_PORTAL_DOCS
export const rumKey = process.env.REACT_APP_RUM_KEY
export const appEnv = process.env.REACT_APP_ENV
// NOTE: Do NOT embed SAS tokens into client builds. Use a backend endpoint that
// mints short-lived SAS tokens. The token used to live in `REACT_APP_AZURE_STORAGE_SAS_TOKEN`
// but it should be removed from `.env` and CI pipelines.

// Minimum AI quality score (0–10) required to move a postmortem to PLATFORMREVIEW
export const rcaMinScoreForSreReview = parseFloat(process.env.REACT_APP_RCA_MIN_SCORE_FOR_SREREVIEW ?? "6")

// Maersk API token credentials (mirrors tools/get_postmortem_token.py)
export const oauthTokenUrl = process.env.REACT_APP_OAUTH_TOKEN_URL
export const postmortemConsumerKey = process.env.REACT_APP_POSTMORTEM_CONSUMER_KEY